<template>
  <div class="form">
    <div class="form__content container">
        <div class="form__items" v-for="(link,index) in links" :key="index">
            <span class="font-40 uppercase">Попробуйте методику<br/> Feels уже сейчас!</span>
            <span class="font-20">Доступ на первую тренировку в приложении.</span>
            <button class="font-16 btn_blue" @click="scrollToSection(link.id)">{{link.name}}</button>
        </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return{ 
      links: [
        {name: 'Получить доступ', id :'feedback' }
      ]
    }
  },
  methods: {
    scrollToSection(link) {
      this.$emit("scroll", link);
    },
  }
}
</script>

<style>

</style>